export default "__VITE_ASSET__DY7Kr5io__"